import { styled, Chip } from '@mui/material';

export const ActivatedChipRoot = styled(Chip)(({ theme }) => ({
  minWidth: 100,
  fontWeight: theme.typography.fontWeightBold,
  textTransform: 'uppercase',
}));
